import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdminAnglerData, LazyAdminAnglerTable, LazyAdminDashboard, LazyAdminEventInvites, LazyAdminEventRoles, LazyAdminJudgeImportModal, LazyAdminJudgeInviteModal, LazyAdminJudgesData, LazyAdminJudgesTable, LazyAdminNoPurchaseData, LazyAdminNoPurchaseTable, LazyAdminNoteEditModal, LazyAdminNotesForUserModal, LazyAdminParticipantsSelector, LazyAdminPendingData, LazyAdminPendingPaymentData, LazyAdminPendingPaymentTable, LazyAdminPendingTable, LazyAdminPickerPresentation, LazyAdminPickerWheel, LazyAdminRafflesCard, LazyAdminRafflesCardInformation, LazyAdminRafflesCardTopPattern, LazyAdminRafflesCartGenerator, LazyAdminRafflesDisplayItemCard, LazyAdminRafflesList, LazyAdminRafflesSelectWinners, LazyAdminRafflesViewPurchase, LazyAdminRaffles, LazyAdminRafflesStyle, LazyAdminRafflesData, LazyAdminRandomWinnersData, LazyAdminRegistrationNav, LazyAdminRegistrationOverview, LazyAdminScoresData, LazyAdminScoresTable, LazyAdminSponsors, LazyAdminTable, LazyAdminTableData, LazyAdminTeamCreateModal, LazyAdminTeamData, LazyAdminTeamPicker, LazyAdminTeamTable, LazyAdminTournamentCreateModal, LazyAdminTournamentData, LazyAdminTournamentInviteCreateModal, LazyAdminTournamentInvites, LazyAdminTournamentTable, LazyAdminTransferSponsorshipModal, LazyAdminUndecidedSeatsData, LazyAdminUndecidedSeatsTable, LazyAdminVendorInquiries, LazyAdminWaitlist, LazyAdminWinnersData, LazyAlerts, LazyAnnouncementsCard, LazyAnnouncementsCreateComponent, LazyAnnouncementsList, LazyAnnouncements, LazyAuctionCatalogItemCard, LazyAuctionCatalogToolbar, LazyAuctionCreateItem, LazyAuctionDisplayItemCard, LazyAuctionImageCropModal, LazyAuctionItemCard, LazyAuctionItemEditModal, LazyAuctionItems, LazyAuctionModal, LazyAuctionProjectorSlide, LazyAuctionPublicCatalog, LazyAuctionWinnerModal, LazyBorrachoEditor, LazyCartActions, LazyCartShoppingBag, LazyChartBar, LazyChartPie, LazyCheckoutActions, LazyCheckoutAddressForm, LazyCheckoutCardInformation, LazyCheckoutPaymentSelect, LazyCheckoutShippingOptions, LazyCheckoutShoppingBag, LazyCommonButton, LazyCommonContainer, LazyCommonContextSelector, LazyCommonDataTable, LazyCommonDropdown, LazyCommonIndicator, LazyCommonLoadingPlaceholder, LazyCommonLogos, LazyCommonOverlay, LazyCommonPageHeader, LazyCommonPopup, LazyCommonServerDataTable, LazyDarkToggle, LazyDashboardNavigation, LazyDashboardPendingInvites, LazyDashboardWelcomePage, LazyDisplayToolbar, LazyDocuseal, LazyDonateCardInformation, LazyDonateForm, LazyDonationsTable, LazyESign, LazyFooter, LazyGuestDocuseal, LazyGuestListTable, LazyHomeComingSoon, LazyIconsCart, LazyIconsCheck, LazyIconsDelete, LazyIconsDownload, LazyIconsEdit, LazyIconsLogo, LazyIconsLogoCircle, LazyIconsLogoHopescador, LazyIconsLogoSmall, LazyIconsNote, LazyIconsPalm, LazyIconsStockMountain, LazyIconsUserCircle, LazyInviteJudge, LazyInvitePage, LazyJudgeRaffles, LazyJudgeScoring, LazyLeaderboardLeaderData, LazyLeaderboardLeaderTable, LazyLoginForm, LazyNoteListTable, LazyPreviewCode, LazyProfileForm, LazyPublicLeaderboardView, LazyRaffleCatalog, LazyResetPasswordForm, LazyRulesMap, LazyRulesSection, LazyRules, LazySchedule, LazySettingsGetter, LazySignup, LazyTableActionMenu, LazyTableActionTrigger, LazyTabs, LazyTeamCompanyPicture, LazyTeamDetails, LazyTextareaAutosize, LazyToolbar, LazyTournamentDetails, LazyUserListTable, LazyWelcomeSingleTeamForm, LazyWelcomeTeamCard, LazyWelcomeTeamForm, LazyWelcomeTeamSelectItem, LazyWelcomeTeamSelector, LazyWelcomeVendorForm, LazyWelcomeVendorInquiryCategoryPills, LazyWelcomeVendorInquiryDeliveryCards, LazyWelcomeVendorInquiryForm, LazyWelcomeVendorInquirySection, LazyYearSelector, LazyMapboxAttributionControl, LazyMapboxCustomGeocoder, LazyMapboxDefaultMarker, LazyMapboxDefaultPopup, LazyMapboxFullscreenControl, LazyMapboxGeocoder, LazyMapboxGeolocateControl, LazyMapboxLayer, LazyMapboxMap, LazyMapboxNavigationControl, LazyMapboxScaleControl, LazyMapboxSource, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["AdminAnglerData", LazyAdminAnglerData],
["AdminAnglerTable", LazyAdminAnglerTable],
["AdminDashboard", LazyAdminDashboard],
["AdminEventInvites", LazyAdminEventInvites],
["AdminEventRoles", LazyAdminEventRoles],
["AdminJudgeImportModal", LazyAdminJudgeImportModal],
["AdminJudgeInviteModal", LazyAdminJudgeInviteModal],
["AdminJudgesData", LazyAdminJudgesData],
["AdminJudgesTable", LazyAdminJudgesTable],
["AdminNoPurchaseData", LazyAdminNoPurchaseData],
["AdminNoPurchaseTable", LazyAdminNoPurchaseTable],
["AdminNoteEditModal", LazyAdminNoteEditModal],
["AdminNotesForUserModal", LazyAdminNotesForUserModal],
["AdminParticipantsSelector", LazyAdminParticipantsSelector],
["AdminPendingData", LazyAdminPendingData],
["AdminPendingPaymentData", LazyAdminPendingPaymentData],
["AdminPendingPaymentTable", LazyAdminPendingPaymentTable],
["AdminPendingTable", LazyAdminPendingTable],
["AdminPickerPresentation", LazyAdminPickerPresentation],
["AdminPickerWheel", LazyAdminPickerWheel],
["AdminRafflesCard", LazyAdminRafflesCard],
["AdminRafflesCardInformation", LazyAdminRafflesCardInformation],
["AdminRafflesCardTopPattern", LazyAdminRafflesCardTopPattern],
["AdminRafflesCartGenerator", LazyAdminRafflesCartGenerator],
["AdminRafflesDisplayItemCard", LazyAdminRafflesDisplayItemCard],
["AdminRafflesList", LazyAdminRafflesList],
["AdminRafflesSelectWinners", LazyAdminRafflesSelectWinners],
["AdminRafflesViewPurchase", LazyAdminRafflesViewPurchase],
["AdminRaffles", LazyAdminRaffles],
["AdminRafflesStyle", LazyAdminRafflesStyle],
["AdminRafflesData", LazyAdminRafflesData],
["AdminRandomWinnersData", LazyAdminRandomWinnersData],
["AdminRegistrationNav", LazyAdminRegistrationNav],
["AdminRegistrationOverview", LazyAdminRegistrationOverview],
["AdminScoresData", LazyAdminScoresData],
["AdminScoresTable", LazyAdminScoresTable],
["AdminSponsors", LazyAdminSponsors],
["AdminTable", LazyAdminTable],
["AdminTableData", LazyAdminTableData],
["AdminTeamCreateModal", LazyAdminTeamCreateModal],
["AdminTeamData", LazyAdminTeamData],
["AdminTeamPicker", LazyAdminTeamPicker],
["AdminTeamTable", LazyAdminTeamTable],
["AdminTournamentCreateModal", LazyAdminTournamentCreateModal],
["AdminTournamentData", LazyAdminTournamentData],
["AdminTournamentInviteCreateModal", LazyAdminTournamentInviteCreateModal],
["AdminTournamentInvites", LazyAdminTournamentInvites],
["AdminTournamentTable", LazyAdminTournamentTable],
["AdminTransferSponsorshipModal", LazyAdminTransferSponsorshipModal],
["AdminUndecidedSeatsData", LazyAdminUndecidedSeatsData],
["AdminUndecidedSeatsTable", LazyAdminUndecidedSeatsTable],
["AdminVendorInquiries", LazyAdminVendorInquiries],
["AdminWaitlist", LazyAdminWaitlist],
["AdminWinnersData", LazyAdminWinnersData],
["Alerts", LazyAlerts],
["AnnouncementsCard", LazyAnnouncementsCard],
["AnnouncementsCreateComponent", LazyAnnouncementsCreateComponent],
["AnnouncementsList", LazyAnnouncementsList],
["Announcements", LazyAnnouncements],
["AuctionCatalogItemCard", LazyAuctionCatalogItemCard],
["AuctionCatalogToolbar", LazyAuctionCatalogToolbar],
["AuctionCreateItem", LazyAuctionCreateItem],
["AuctionDisplayItemCard", LazyAuctionDisplayItemCard],
["AuctionImageCropModal", LazyAuctionImageCropModal],
["AuctionItemCard", LazyAuctionItemCard],
["AuctionItemEditModal", LazyAuctionItemEditModal],
["AuctionItems", LazyAuctionItems],
["AuctionModal", LazyAuctionModal],
["AuctionProjectorSlide", LazyAuctionProjectorSlide],
["AuctionPublicCatalog", LazyAuctionPublicCatalog],
["AuctionWinnerModal", LazyAuctionWinnerModal],
["BorrachoEditor", LazyBorrachoEditor],
["CartActions", LazyCartActions],
["CartShoppingBag", LazyCartShoppingBag],
["ChartBar", LazyChartBar],
["ChartPie", LazyChartPie],
["CheckoutActions", LazyCheckoutActions],
["CheckoutAddressForm", LazyCheckoutAddressForm],
["CheckoutCardInformation", LazyCheckoutCardInformation],
["CheckoutPaymentSelect", LazyCheckoutPaymentSelect],
["CheckoutShippingOptions", LazyCheckoutShippingOptions],
["CheckoutShoppingBag", LazyCheckoutShoppingBag],
["CommonButton", LazyCommonButton],
["CommonContainer", LazyCommonContainer],
["CommonContextSelector", LazyCommonContextSelector],
["CommonDataTable", LazyCommonDataTable],
["CommonDropdown", LazyCommonDropdown],
["CommonIndicator", LazyCommonIndicator],
["CommonLoadingPlaceholder", LazyCommonLoadingPlaceholder],
["CommonLogos", LazyCommonLogos],
["CommonOverlay", LazyCommonOverlay],
["CommonPageHeader", LazyCommonPageHeader],
["CommonPopup", LazyCommonPopup],
["CommonServerDataTable", LazyCommonServerDataTable],
["DarkToggle", LazyDarkToggle],
["DashboardNavigation", LazyDashboardNavigation],
["DashboardPendingInvites", LazyDashboardPendingInvites],
["DashboardWelcomePage", LazyDashboardWelcomePage],
["DisplayToolbar", LazyDisplayToolbar],
["Docuseal", LazyDocuseal],
["DonateCardInformation", LazyDonateCardInformation],
["DonateForm", LazyDonateForm],
["DonationsTable", LazyDonationsTable],
["ESign", LazyESign],
["Footer", LazyFooter],
["GuestDocuseal", LazyGuestDocuseal],
["GuestListTable", LazyGuestListTable],
["HomeComingSoon", LazyHomeComingSoon],
["IconsCart", LazyIconsCart],
["IconsCheck", LazyIconsCheck],
["IconsDelete", LazyIconsDelete],
["IconsDownload", LazyIconsDownload],
["IconsEdit", LazyIconsEdit],
["IconsLogo", LazyIconsLogo],
["IconsLogoCircle", LazyIconsLogoCircle],
["IconsLogoHopescador", LazyIconsLogoHopescador],
["IconsLogoSmall", LazyIconsLogoSmall],
["IconsNote", LazyIconsNote],
["IconsPalm", LazyIconsPalm],
["IconsStockMountain", LazyIconsStockMountain],
["IconsUserCircle", LazyIconsUserCircle],
["InviteJudge", LazyInviteJudge],
["InvitePage", LazyInvitePage],
["JudgeRaffles", LazyJudgeRaffles],
["JudgeScoring", LazyJudgeScoring],
["LeaderboardLeaderData", LazyLeaderboardLeaderData],
["LeaderboardLeaderTable", LazyLeaderboardLeaderTable],
["LoginForm", LazyLoginForm],
["NoteListTable", LazyNoteListTable],
["PreviewCode", LazyPreviewCode],
["ProfileForm", LazyProfileForm],
["PublicLeaderboardView", LazyPublicLeaderboardView],
["RaffleCatalog", LazyRaffleCatalog],
["ResetPasswordForm", LazyResetPasswordForm],
["RulesMap", LazyRulesMap],
["RulesSection", LazyRulesSection],
["Rules", LazyRules],
["Schedule", LazySchedule],
["SettingsGetter", LazySettingsGetter],
["Signup", LazySignup],
["TableActionMenu", LazyTableActionMenu],
["TableActionTrigger", LazyTableActionTrigger],
["Tabs", LazyTabs],
["TeamCompanyPicture", LazyTeamCompanyPicture],
["TeamDetails", LazyTeamDetails],
["TextareaAutosize", LazyTextareaAutosize],
["Toolbar", LazyToolbar],
["TournamentDetails", LazyTournamentDetails],
["UserListTable", LazyUserListTable],
["WelcomeSingleTeamForm", LazyWelcomeSingleTeamForm],
["WelcomeTeamCard", LazyWelcomeTeamCard],
["WelcomeTeamForm", LazyWelcomeTeamForm],
["WelcomeTeamSelectItem", LazyWelcomeTeamSelectItem],
["WelcomeTeamSelector", LazyWelcomeTeamSelector],
["WelcomeVendorForm", LazyWelcomeVendorForm],
["WelcomeVendorInquiryCategoryPills", LazyWelcomeVendorInquiryCategoryPills],
["WelcomeVendorInquiryDeliveryCards", LazyWelcomeVendorInquiryDeliveryCards],
["WelcomeVendorInquiryForm", LazyWelcomeVendorInquiryForm],
["WelcomeVendorInquirySection", LazyWelcomeVendorInquirySection],
["YearSelector", LazyYearSelector],
["MapboxAttributionControl", LazyMapboxAttributionControl],
["MapboxCustomGeocoder", LazyMapboxCustomGeocoder],
["MapboxDefaultMarker", LazyMapboxDefaultMarker],
["MapboxDefaultPopup", LazyMapboxDefaultPopup],
["MapboxFullscreenControl", LazyMapboxFullscreenControl],
["MapboxGeocoder", LazyMapboxGeocoder],
["MapboxGeolocateControl", LazyMapboxGeolocateControl],
["MapboxLayer", LazyMapboxLayer],
["MapboxMap", LazyMapboxMap],
["MapboxNavigationControl", LazyMapboxNavigationControl],
["MapboxScaleControl", LazyMapboxScaleControl],
["MapboxSource", LazyMapboxSource],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
